
  import Sticker from "@/components/sticker.vue";

  export default {
    name: "IntioWord",
    components: {
      Sticker,
    }
  };
